import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../../core/services/auth.service";
import { UserService } from "../../account/services/user.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthService,
    private userClient: UserService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.userClient.updateUser$().pipe(
      map((res) => {
        const isLoggedIn = this.auth.isLoggedIn();

        if (!isLoggedIn) {
          this.router.navigate(["/"]);
        }

        return isLoggedIn;
      }),
      catchError((err, caught) => {
        const isLoggedIn = this.auth.isLoggedIn();

        if (!isLoggedIn) {
          this.router.navigate(["/"]);
        }

        return of(isLoggedIn);
      })
    );
  }
}
